import { isNil, isEmpty as isEmptyRamda, anyPass, complement } from "ramda";
import { version } from "../../package.json";

export const env = process.env.NODE_ENV;

export const appVersion = env === "production" ? version : `${version}-staging`;

export function isEmpty(array) {
  return !array || array.length <= 0;
}

export function isNotNilOrEmpty(thing) {
  return complement(anyPass([isNil, isEmptyRamda]))(thing);
}

export function calculateSubtotal(lineItems) {
  return lineItems
    .map((item) => Number(item.quantity) * Number(item.unitNetPrice || 0))
    .reduce((current, incoming) => current + incoming, 0)
    .toFixed(2);
}

export function getAttributeValue(attributes, key, defaultValue) {
  const attribute = (attributes || []).find((attr) => attr.key === key);
  return (attribute && attribute.value) || defaultValue;
}

export function setAttributeValue(attributes, key, value) {
  const attribute = attributes.find((attr) => attr.key === key);
  if (attribute) {
    attribute.value = value;
  } else {
    attributes.push({ key, value });
  }
}

export function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function isAlipayBrowser() {
  return navigator.userAgent.toLowerCase().includes("alipay");
}

export const featureToggle = {
  DISALLOW_SAME_DAY_WEEKEND_DELIVERY: false,
  HOMEPAGE_SIGNUPIN_DIALOG: false,
  MEMBERSHIP: true,
};

export function validateMobilePrefix(_, value, cb) {
  if (!value.startsWith("04")) {
    return cb(
      new Error(
        "Please type a valid Australian mobile number 请输入有效澳洲手机号"
      )
    );
  }
  cb();
}

export const CONFIG_KEYS = {
  selectedMode: "kingdynasty_ec_home_options_selected_mode",
  reservationId: "kingdynasty_ec_reservation_id",
};

export const isDineInEnabled = true;
export const isCovidCheckInEnabled = false;
export const isPickupAsapEnabled = false;
